import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import './styles/globals.css';
import './sw-updater.js';

// 启动时读 URL 的 ?ref=XXXX 推荐码,登录时自动用上
try {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref && /^[A-Z2-9]{6}$/.test(ref)) {
    localStorage.setItem('fucai3d_referral_code', ref);
    // URL 清掉,避免泄露到分享路径
    const url = new URL(window.location.href);
    url.searchParams.delete('ref');
    window.history.replaceState({}, '', url.toString());
  }
} catch (e) {}

// 强制使用 dark 模式(品牌主色)
try {
  localStorage.setItem('fucai3d_theme', 'dark');
  document.documentElement.setAttribute('data-theme', 'dark');
} catch (e) {}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
